export default "__VITE_ASSET__CU8JKd50__"